export const getOnlineTransactionsListContainerStyle = (theme) => ({
    width: '740px',
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center'
});